// Cookie-backed request config for authenticated API calls (T201).
// The browser sends the httpOnly nd_access/nd_refresh cookies; JavaScript never reads them.

export const getAuthHeader = () => ({
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});
